<template>
  <div class="print-box" v-if="isOpen">
    <el-dialog
      class="print-box-dialog"
      v-model="newIsOpen"
      top="-200vh"
      :show-close="false"
      :fullscreen="!isMobile"
      :append-to-body="!isMobile"
      destroy-on-close
      :modal="false">
      <!-- 头部 -->
      
      <div class="mask-box" v-show="!dialogVisible">
        <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/download.gif" alt="">
        <span class="mask-box-text">数据加载中请稍后</span>
          <!-- <i class="iconfont icon-tianjia1" @click="isLoading = false"></i> -->
        <!-- <el-button @click="dialogVisible = false">关闭</el-button> -->
      </div>
      <template v-if="!isAllFiles && dialogVisible">
        <reportView
          ref="reportView"
          :config="detailConfig"
          :tableData="tableData"
          :isApproval="true"
          :isMobile="isMobile"
          :auditList="auditList"
          :auditbuttonList="auditbuttonList"
          @imageHandler="(page) => { $emit('imageHandler', page) }"
          @close="dialogVisible = false"
        />
      </template>
      <reportView
        v-if="filesDialogVisible"
        ref="reportView"
        :config="detailConfig"
        :tableData="tableData"
        :isApproval="true"
        :isAllFiles="isAllFiles"
        @close="dialogVisible = false"
        @allFileCallBack="allFileCallBack"
      />
		</el-dialog>
	</div>
</template>

<script>
  import html2canvas from 'html2canvas'
  import reportView from '@/components/reportView/index'
  
  const base64 = s => window.btoa(unescape(encodeURIComponent(s)));
	export default {
		data() {
			return {
				dialogVisible: false,
        filesDialogVisible: false,
        isLoading: false,
        tableData: {},
        fileIndex: 0,
        newIsOpen: false
			}
		},
		props: {
			detailConfig: {
				type: Object,
				default: () => {}
			},
			formdata: {
				type: Object,
				default: () => {} 
			},
      allFileData: {
        type: Array,
				default: () => []
      },
      allFileDataLength: {
        type: Number,
        default: 0
      },
			title: {
				type: String,
				default: '模板1'
			},
      isView: {
        type: Boolean,
				default: false
      },
      isOpen: {
        type: Boolean,
				default: false
      },
      isAllFiles: { // 是否是批量
        type: Boolean,
				default: false
      },
      isMobile: {
        type: Boolean,
				default: false
      },
      deptGroup: { // 国贸的工资表
				type: Object,
				default: () => {}
			},
      auditList: { // 流程数据
        type: Array,
				default: () => []
      },
      auditbuttonList: { // 流程按钮
        type: Array,
				default: () => []
      }
		},
		computed: {
      getDataSource () {
        return this.detailConfig.dataSource.formList ? this.detailConfig.dataSource.formList.map(item => {
          return item.appid
        }) : []
      }
    },
    components: {
      reportView
    },
		watch: {
      newIsOpen: {
        handler (val) {
          if (!val) {
            this.$emit('update:isOpen', false)
          }
        },
      },
      isView: {
        handler(val) {
          if (val) {
            this.dialogVisible = val
          }
        },
        immediate: true
      },
      isOpen: {
        handler(val) {
          if (val) {
            this.newIsOpen = val
          }
        },
        immediate: true
      },
			dialogVisible: {
				handler(val) {
					if (!val) {
						console.log('关闭')
						this.$emit('close')
            this.$emit('update:isOpen', false)
            this.$emit('update:isView', false)
					} else {
            console.log('显示报表')
					}
				}
			},
      formdata: {
        handler(newVal) {
          if (JSON.stringify(newVal) !== '{}') {
            this.tableData = JSON.parse(JSON.stringify(newVal))
          }
        },
        deep: true
      },
      allFileData: {
        handler(newVal) {
          if (this.isAllFiles && this.isView && newVal.length > 0) {
            this.tableData = JSON.parse(JSON.stringify(newVal[this.fileIndex]))
            this.filesDialogVisible = true
            this.dialogVisible = true
          }
        },
        deep: true,
        immediate: true
      }
		},
    methods: {
      async toPng (id) {
        this.isLoading = true
        this.$nextTick(async () => {
          const ElPrint = document.querySelector(id)
          // 使用html2canvas将Vue组件渲染为图片
          const canvas = await html2canvas(ElPrint, {
            scale: 2, // 处理模糊问题
            dpi: 300, // 处理模糊问题
            useCORS: true, // 是否尝试使用CORS从服务器加载图像
          })
          var save_url = canvas.toDataURL("image/png");
          var aLink = document.createElement("a");
          document.body.appendChild(aLink);
          aLink.href = save_url;
          aLink.download = `${this.detailConfig.canvasName}`;
          aLink.click();
          document.body.removeChild(aLink);
          this.isLoading = false
        })
      },
      toExcel (id) {
        this.isLoading = true
        const worksheet = 'Sheet1'
        const uri = 'data:application/vnd.ms-excel;base64,';
        let table = document.querySelector(id)  
        const str = table.outerHTML                    
        // 下载的表格模板数据
        const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office" 
        xmlns:x="urn:schemas-microsoft-com:office:excel" 
        xmlns="http://www.w3.org/TR/REC-html40">
        <head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
        <x:Name>${worksheet}</x:Name>
        <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>
        </x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
        <style>td{text-align: center;}<style>
        </head><body>${str}></body></html>`;
        // 下载模板
        var aLink = document.createElement("a");
        document.body.appendChild(aLink);
        aLink.href = uri + base64(template)
        aLink.download = `${this.detailConfig.canvasName}`;
        aLink.click();
        document.body.removeChild(aLink);
        this.isLoading = false
      },
      allFileCallBack () {
        if (this.isAllFiles && this.allFileData[this.fileIndex + 1]) {
          this.fileIndex++
          this.tableData = JSON.parse(JSON.stringify(this.allFileData[this.fileIndex]))
          this.$refs.reportView.handleCurrentChange(1)
        }
      },
    }
	}
</script>

<style lang="scss" scoped> 
	.pox-title {
		height: 54px;
		background-color: #F5F5F5;
		padding: 0 24px;
		border-radius: 4px 4px 0px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title-mode {
      // position: relative;
      // left: 100px
    }
    :deep(.el-button) {
      padding: 8px 16px;
    }
	}
  .mask-box {
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    .mask-box-text {
      color: #FFFFFF;
      font-size: 16px;
      position: relative;
      top: -60px;
    }
    .icon-tianjia1 {
      color: #FFFFFF;
      font-size: 32px;
      position: absolute;
      right: -15px;
      top: -15px;
      transform: rotate(45deg);
      cursor: pointer;
    }
    .el-button {
      position: fixed;
      right: 20px;
      top: 20px;
    }
  }
</style>
<style>
/* 这里是全局样式，可以穿透并修改 Dialog */
.print-box-dialog {
  padding: 0 !important;
}
.print-box-dialog .el-dialog__body {
  background-color: #000;
  height: 100%;
  padding: 0px;
  overflow: hidden;
  color: #000000;
}
.print-box-dialog .el-dialog__header {
  padding: 0 !important;
}
</style>